import { defineComponent as u, openBlock as o, createElementBlock as e, mergeProps as i, unref as l, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as h } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, H = { key: 1 }, k = { key: 2 }, M = { key: 3 }, Z = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconNumberSeven"
}, L = /* @__PURE__ */ u({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = h(s);
    return (p, t) => (o(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      g(p.$slots, "default"),
      l(a) === "bold" ? (o(), e("g", f, t[0] || (t[0] = [
        n("path", { d: "M179.49,51.45l-48,160A12,12,0,0,1,120,220a11.82,11.82,0,0,1-3.45-.51,12,12,0,0,1-8-14.94L151.87,60H88a12,12,0,0,1,0-24h80a12,12,0,0,1,11.49,15.45Z" }, null, -1)
      ]))) : l(a) === "duotone" ? (o(), e("g", H, t[1] || (t[1] = [
        n("path", {
          d: "M216,40V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V40A16,16,0,0,1,56,24H200A16,16,0,0,1,216,40Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M175.66,50.3l-48,160a8,8,0,0,1-15.32-4.6L157.25,56H88a8,8,0,0,1,0-16h80a8,8,0,0,1,7.66,10.3Z" }, null, -1)
      ]))) : l(a) === "fill" ? (o(), e("g", k, t[2] || (t[2] = [
        n("path", { d: "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM167.53,74.69l-40,112a8,8,0,1,1-15.06-5.38L148.65,80H96a8,8,0,0,1,0-16h64a8,8,0,0,1,7.53,10.69Z" }, null, -1)
      ]))) : l(a) === "light" ? (o(), e("g", M, t[3] || (t[3] = [
        n("path", { d: "M173.75,49.72l-48,160a6,6,0,1,1-11.5-3.45L159.94,54H88a6,6,0,0,1,0-12h80a6,6,0,0,1,5.75,7.72Z" }, null, -1)
      ]))) : l(a) === "regular" ? (o(), e("g", Z, t[4] || (t[4] = [
        n("path", { d: "M175.66,50.3l-48,160a8,8,0,0,1-15.32-4.6L157.25,56H88a8,8,0,0,1,0-16h80a8,8,0,0,1,7.66,10.3Z" }, null, -1)
      ]))) : l(a) === "thin" ? (o(), e("g", w, t[5] || (t[5] = [
        n("path", { d: "M171.83,49.15l-48,160A4,4,0,0,1,120,212a3.82,3.82,0,0,1-1.15-.17,4,4,0,0,1-2.68-5L162.62,52H88a4,4,0,0,1,0-8h80a4,4,0,0,1,3.83,5.15Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  L as default
};
